module.exports = __webpack_public_path__ + "static/media/understand_bg.640ea171.png";